import { render, staticRenderFns } from "./LogoutPage.vue?vue&type=template&id=5f90faf3&scoped=true"
import script from "./LogoutPage.vue?vue&type=script&lang=js"
export * from "./LogoutPage.vue?vue&type=script&lang=js"
import style0 from "./LogoutPage.vue?vue&type=style&index=0&id=5f90faf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f90faf3",
  null
  
)

export default component.exports